// extracted by mini-css-extract-plugin
export default {"navThumbnail":"ksL6FJV8ySjva6QgbPha"};